
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5qO2k", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $cXtTj = parcelRequire("cXtTj");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $8f621f3867006eb3$export$e8ff3768de40dcb2 = ()=>(parcelRequire("5AAF6"));



var $hyOW3 = parcelRequire("hyOW3");


var $fDOrD = parcelRequire("fDOrD");


var $jv1SC = parcelRequire("jv1SC");

const $6e95e9a207754122$var$PRELOADER_SMART_CARD = 'smart-card';
const $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $6e95e9a207754122$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $6e95e9a207754122$var$ALL_PRELOADERS = [
    $6e95e9a207754122$var$PRELOADER_SMART_CARD,
    $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST,
    $6e95e9a207754122$var$PRELOADER_SMART_CREATION,
    $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG
];
let $6e95e9a207754122$var$hasPreloadedChatOnIntent = false;
function $6e95e9a207754122$var$isPreloaderName(preloader) {
    return $6e95e9a207754122$var$ALL_PRELOADERS.includes(preloader);
}
function $6e95e9a207754122$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($6e95e9a207754122$var$isPreloaderName));
}
function $6e95e9a207754122$var$preloadSmartCard() {
    (0, $8f621f3867006eb3$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadAutoSuggest() {
    (0, $hyOW3.importAutoSuggest)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadSmartCreationWrapper() {
    (0, $jv1SC.importSmartCreationWrapper)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadFeedbackFlag() {
    (0, $fDOrD.importFeedbackFlag)().catch(()=>{});
}
function $6e95e9a207754122$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($6e95e9a207754122$var$hasPreloadedChatOnIntent) return;
    $6e95e9a207754122$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $6e95e9a207754122$var$getEnabledPreloaders((0, $cXtTj.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CARD)) $6e95e9a207754122$var$preloadSmartCard();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST)) $6e95e9a207754122$var$preloadAutoSuggest();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CREATION)) $6e95e9a207754122$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG)) $6e95e9a207754122$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $6e95e9a207754122$export$778f6ecee92cc30c;

});

parcelRegister("5AAF6", function(module, exports) {

let $411cc0d5a2a55f53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $411cc0d5a2a55f53$var$load("Kj0I8"),
    $411cc0d5a2a55f53$var$load("5xnun"),
    $411cc0d5a2a55f53$var$load("iUXaE"),
    $411cc0d5a2a55f53$var$load("lTkx9"),
    $411cc0d5a2a55f53$var$load("eRhBr"),
    $411cc0d5a2a55f53$var$load("6HpsR"),
    $411cc0d5a2a55f53$var$load("N3oqb"),
    $411cc0d5a2a55f53$var$load("hZ2FX"),
    $411cc0d5a2a55f53$var$load("9ZFGK"),
    $411cc0d5a2a55f53$var$load("2hLAI"),
    $411cc0d5a2a55f53$var$load("dCilB"),
    $411cc0d5a2a55f53$var$load("h1yOv"),
    $411cc0d5a2a55f53$var$load("1T8H1"),
    $411cc0d5a2a55f53$var$load("fyKFO"),
    $411cc0d5a2a55f53$var$load("d9sg7"),
    $411cc0d5a2a55f53$var$load("l0N35"),
    $411cc0d5a2a55f53$var$load("bU9L5"),
    $411cc0d5a2a55f53$var$load("fuOfV"),
    $411cc0d5a2a55f53$var$load("iZR3N"),
    $411cc0d5a2a55f53$var$load("4zz48"),
    $411cc0d5a2a55f53$var$load("jXM1T"),
    $411cc0d5a2a55f53$var$load("cvcNg"),
    $411cc0d5a2a55f53$var$load("jw3lv"),
    $411cc0d5a2a55f53$var$load("7rqWx"),
    $411cc0d5a2a55f53$var$load("aIze1"),
    $411cc0d5a2a55f53$var$load("il8bj"),
    $411cc0d5a2a55f53$var$load("4N1MY"),
    $411cc0d5a2a55f53$var$load("kG5Ju"),
    $411cc0d5a2a55f53$var$load("39XCn"),
    $411cc0d5a2a55f53$var$load("3Cky6"),
    $411cc0d5a2a55f53$var$load("jL1Ke"),
    $411cc0d5a2a55f53$var$load("5MQ0D"),
    $411cc0d5a2a55f53$var$load("aFLSJ"),
    $411cc0d5a2a55f53$var$load("6fJCf"),
    $411cc0d5a2a55f53$var$load("duEFL"),
    $411cc0d5a2a55f53$var$load("6wr18"),
    $411cc0d5a2a55f53$var$load("1pJPT"),
    $411cc0d5a2a55f53$var$load("8zMmc"),
    $411cc0d5a2a55f53$var$load("4x9Jx"),
    $411cc0d5a2a55f53$var$load("7EorR"),
    $411cc0d5a2a55f53$var$load("ffEVr"),
    $411cc0d5a2a55f53$var$load("2EIkU"),
    $411cc0d5a2a55f53$var$load("Wowvf"),
    $411cc0d5a2a55f53$var$load("hhss7"),
    $411cc0d5a2a55f53$var$load("cbF85")
]).then(()=>parcelRequire('9gHOR'));

});

parcelRegister("hyOW3", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $04373e772f510be6$export$5531859f311f2932() {
    return (parcelRequire("8Bx4L"));
}
module.exports["importAutoSuggest"] = $04373e772f510be6$export$5531859f311f2932;

});

parcelRegister("8Bx4L", function(module, exports) {

let $643b6f94a2aaf625$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $643b6f94a2aaf625$var$load("iUXaE"),
    $643b6f94a2aaf625$var$load("lTkx9"),
    $643b6f94a2aaf625$var$load("6wr18"),
    $643b6f94a2aaf625$var$load("ffEVr"),
    $643b6f94a2aaf625$var$load("eCXJR"),
    $643b6f94a2aaf625$var$load("1VTX2"),
    $643b6f94a2aaf625$var$load("2EIkU"),
    $643b6f94a2aaf625$var$load("eRhBr"),
    $643b6f94a2aaf625$var$load("hZ2FX"),
    $643b6f94a2aaf625$var$load("hhss7"),
    $643b6f94a2aaf625$var$load("kT6dz"),
    $643b6f94a2aaf625$var$load("aAWLw"),
    $643b6f94a2aaf625$var$load("lRgOm")
]).then(()=>parcelRequire('79mXg'));

});

parcelRegister("fDOrD", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $e837e744ff2037be$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("wRQb5"));
module.exports["importFeedbackFlag"] = $e837e744ff2037be$export$1eafe3a5df99a0a0;

});

parcelRegister("wRQb5", function(module, exports) {

let $062cc0e3f374f5be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $062cc0e3f374f5be$var$load("hMCSF").then(()=>parcelRequire('3XAon'));

});

parcelRegister("jv1SC", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $bf344f5862a0f71d$export$f67978e62543a686 = ()=>(parcelRequire("d5399"));
module.exports["importSmartCreationWrapper"] = $bf344f5862a0f71d$export$f67978e62543a686;

});

parcelRegister("d5399", function(module, exports) {

let $985e2edbdb23faf6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $985e2edbdb23faf6$var$load("4ZKBo"),
    $985e2edbdb23faf6$var$load("3WmaY"),
    $985e2edbdb23faf6$var$load("7TnhR"),
    $985e2edbdb23faf6$var$load("hUbK8"),
    $985e2edbdb23faf6$var$load("gwGEC"),
    $985e2edbdb23faf6$var$load("l5nRU"),
    $985e2edbdb23faf6$var$load("bx5S2"),
    $985e2edbdb23faf6$var$load("7fsAO"),
    $985e2edbdb23faf6$var$load("1tkCm"),
    $985e2edbdb23faf6$var$load("ipIDQ"),
    $985e2edbdb23faf6$var$load("7eTC9"),
    $985e2edbdb23faf6$var$load("agv3Q"),
    $985e2edbdb23faf6$var$load("garBx"),
    $985e2edbdb23faf6$var$load("2CrXe"),
    $985e2edbdb23faf6$var$load("beMmd"),
    $985e2edbdb23faf6$var$load("l4MHo"),
    $985e2edbdb23faf6$var$load("k97np"),
    $985e2edbdb23faf6$var$load("3cN9G"),
    $985e2edbdb23faf6$var$load("j3345"),
    $985e2edbdb23faf6$var$load("2J2X1"),
    $985e2edbdb23faf6$var$load("jp1ZJ"),
    $985e2edbdb23faf6$var$load("jgxNN"),
    $985e2edbdb23faf6$var$load("e7Dyr"),
    $985e2edbdb23faf6$var$load("ig9dh"),
    $985e2edbdb23faf6$var$load("hA8hA"),
    $985e2edbdb23faf6$var$load("fldAO"),
    $985e2edbdb23faf6$var$load("2NEDA"),
    $985e2edbdb23faf6$var$load("dxcsb"),
    $985e2edbdb23faf6$var$load("gbejv"),
    $985e2edbdb23faf6$var$load("GD9EA"),
    $985e2edbdb23faf6$var$load("2hLAI"),
    $985e2edbdb23faf6$var$load("dCilB"),
    $985e2edbdb23faf6$var$load("1T8H1"),
    $985e2edbdb23faf6$var$load("fyKFO"),
    $985e2edbdb23faf6$var$load("d9sg7"),
    $985e2edbdb23faf6$var$load("l0N35"),
    $985e2edbdb23faf6$var$load("gnocL"),
    $985e2edbdb23faf6$var$load("Kj0I8"),
    $985e2edbdb23faf6$var$load("5xnun"),
    $985e2edbdb23faf6$var$load("bgstx"),
    $985e2edbdb23faf6$var$load("8exG0"),
    $985e2edbdb23faf6$var$load("kT6dz"),
    $985e2edbdb23faf6$var$load("jZMUd"),
    $985e2edbdb23faf6$var$load("iUXaE"),
    $985e2edbdb23faf6$var$load("lTkx9"),
    $985e2edbdb23faf6$var$load("6wr18"),
    $985e2edbdb23faf6$var$load("bpmjT"),
    $985e2edbdb23faf6$var$load("hZVEi"),
    $985e2edbdb23faf6$var$load("fcsnw"),
    $985e2edbdb23faf6$var$load("ffEVr"),
    $985e2edbdb23faf6$var$load("eCXJR"),
    $985e2edbdb23faf6$var$load("1VTX2"),
    $985e2edbdb23faf6$var$load("ddvkk"),
    $985e2edbdb23faf6$var$load("3upHR"),
    $985e2edbdb23faf6$var$load("hhss7"),
    $985e2edbdb23faf6$var$load("Wowvf"),
    $985e2edbdb23faf6$var$load("eRhBr"),
    $985e2edbdb23faf6$var$load("hZ2FX"),
    $985e2edbdb23faf6$var$load("cKDij"),
    $985e2edbdb23faf6$var$load("7EorR"),
    $985e2edbdb23faf6$var$load("ce05o"),
    $985e2edbdb23faf6$var$load("4CnWt")
]).then(()=>parcelRequire('j1zzQ'));

});


//# sourceMappingURL=preload-chat-on-intent.86f0530e.js.map
